// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".links{margin-top:5%}.links .link-container{padding-left:25%;padding-right:25%;width:100%}.links .mx-autolux{margin-left:30%;margin-right:30%}", ""]);
// Exports
module.exports = exports;
